import { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

const Background = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      options={{
        fullScreen: { enable: true },
        background: { color: "#1E2A38" },
        particles: {
          number: { value: 100 },
          size: { value: 3 },
          move: { enable: true, speed: 0.5 },
          color: { value: "#ffffff" },
          opacity: { value: 0.4 },
          links: {
            enable: true,
            distance: 120,
            color: "#ffffff",
            opacity: 0.2,
            width: 1,
          },
        },
        detectRetina: true,
      }}
      style={{ position: "absolute", zIndex: -1 }}
    />
  );
};

export default Background;
